import { useMutation, useQuery } from "@tanstack/react-query";
import { designApiService } from "modules/Library/Design/api/design.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const useDesignService = (
  searchtext?: string | null,
  currentpage?: number,
  pagesize?: number,
) => {
  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => designApiService.insertData(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => designApiService.updateData(payload),
  });

  const DeleteMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => designApiService.deleteData(payload),
  });

  const SelectAllQuery = useQuery<ApiResponse, Error>({
    queryKey: ["design-select-all", searchtext, currentpage, pagesize],
    queryFn: () =>
      designApiService.selectAllData(searchtext, currentpage, pagesize),
    enabled: !!currentpage && !!pagesize,
  });

  return { InsertMutation, UpdateMutation, DeleteMutation, SelectAllQuery };
};
